import { IAdmin } from 'domain/store/admin/AdminModel';
import { useStore } from './useStore';

export function useAdmin(): IAdmin {
  const { admin } = useStore();

  return admin;
}
